export default "__VITE_ASSET__90141a41__"